export type CatDatepickerMode = 'date' | 'time' | 'datetime' | 'daterange' | 'week';
